import { useEffect, useState } from 'react'
import { Portal } from '@ark-ui/react'
import { useRouter } from 'next/router'
import { TbMenu2, TbX } from 'react-icons/tb'

import { IconButton, IconButtonProps } from 'components/Button/IconButton'
import { Box, Grid, HStack } from 'styled-system/jsx'

import { BackToIntegrationAppLogo } from '../BackToIntegrationAppLogo'
import { BackToWorkspaceLink } from '../BackToWorkspaceLink'
import { FullDocsMenu } from '../DocsMenu/TreeStyleDocsMenu'

export function MobileMenuButton(props: Partial<IconButtonProps>) {
  const [opened, setOpened] = useState(false)
  function toggleMenu() {
    setOpened(!opened)
  }

  useEffect(() => {
    if (opened) {
      document.body.classList.add('overflow-hidden')
    } else {
      document.body.classList.remove('overflow-hidden')
    }

    return () => {
      document.body.classList.remove('overflow-hidden')
    }
  }, [opened])

  return (
    <>
      <StyledIconButton
        onClick={toggleMenu}
        variant='subtle'
        tooltip='Open menu'
        {...props}
      >
        <TbMenu2 />
      </StyledIconButton>
      {opened && <MobileMenu onMenuClose={toggleMenu} />}
    </>
  )
}

function MobileMenu({ onMenuClose }: { onMenuClose: () => void }) {
  const router = useRouter()

  useEffect(() => {
    // Track route changes and close menu when user navigates to other page
    router.events.on('routeChangeComplete', onMenuClose)
    return () => {
      router.events.off('routeChangeComplete', onMenuClose)
    }
  }, [router, onMenuClose])

  return (
    <Portal>
      <Grid
        gridTemplateAreas='"header" "menu"'
        gridTemplateRows='min-content 1fr'
        position='absolute'
        inset='0'
        paddingBlock='2'
        backgroundColor='bg.default'
        zIndex='overlay'
        animation='fade-in'
      >
        <HStack
          paddingInline='7'
          justifyContent='space-between'
          gridArea='header'
        >
          <HStack gap='3'>
            <StyledIconButton
              onClick={onMenuClose}
              variant='outline'
              tooltip='Close menu'
            >
              <TbX />
            </StyledIconButton>
            <BackToIntegrationAppLogo />
          </HStack>
          <BackToWorkspaceLink />
        </HStack>
        <Box paddingInline='7' gridArea='menu' overflowY='auto' minHeight='0'>
          <FullDocsMenu />
        </Box>
      </Grid>
    </Portal>
  )
}

function StyledIconButton(props: IconButtonProps) {
  return (
    <IconButton
      display={{
        base: 'block',
        sm: 'none',
      }}
      {...props}
    />
  )
}
